import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=dd539204&scoped=true&lang=pug&"
import script from "./Menu.vue?vue&type=script&lang=coffee&"
export * from "./Menu.vue?vue&type=script&lang=coffee&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=dd539204&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd539204",
  null
  
)

export default component.exports